import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const EngineStatusCircle = styled.div<{ $color: string; theme: { token: GlobalToken } }>`
  flex-shrink: 0;
  width: ${({ theme: { token } }) => token.fontSizeSM / 2}px;
  height: ${({ theme: { token } }) => token.fontSizeSM / 2}px;
  border-radius: 50%;
  display: inline-block;
  background-color: ${({ $color }) => $color};
`;

export const TooltipContainer = styled.div<{ theme: { token: GlobalToken } }>`
  position: relative;
  padding: ${({ theme: { token } }) => token.paddingXS}px 0;
  background-color: ${({ theme: { token } }) => token.colorBgElevated};
  border-radius: 4px;
  font-size: ${({ theme: { token } }) => token.fontSize}px;
  box-shadow: ${({ theme: { token } }) => token.boxShadowSecondary};

  color: ${({ theme: { token } }) => token.colorText};
  z-index: 10;

  .average-label {
    text-align: center;
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
  }

  .date {
    display: flex;
    justify-content: center;
    padding: ${({ theme: { token } }) => `${token.paddingXXS}px ${token.padding}px`};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorText};
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    margin: ${({ theme: { token } }) => `${token.marginXXS}px ${token.margin}px ${token.marginXS}px ${token.margin}px`};
    background-color: ${({ theme: { token } }) => token.colorBgContainer};
    border-radius: 2px;

    .utc-offset-text {
      color: ${({ theme: { token } }) => token.colorText};
      margin-left: ${({ theme: { token } }) => token.marginXXS}px;
    }
  }

  .column-flex {
    flex-direction: column;
    align-items: center;
  }

  .dynamic-controller-body {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .dynamic-controller-table {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: ${({ theme: { token } }) => token.marginXS}px;
  }

  .dynamic-controller-label {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
  }

  &.dynamic-control-tooltip-container {
    display: flex;
  }

  table.metrics {
    width: 100%;

    .border-bottom {
      border-bottom: 0.5px solid ${({ theme: { token } }) => token.colorTextSecondary};
    }

    tr:not(:first-child) .group-title {
      margin-top: ${({ theme: { token } }) => token.marginXS}px;
    }

    tr {
      .padding-bottom {
        padding-bottom: ${({ theme: { token } }) => token.paddingXS}px;
      }

      .display-flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .metric-name {
        display: flex;
        align-items: center;
        padding-left: ${({ theme: { token } }) => token.padding}px;
      }

      .metric-value {
        padding-right: ${({ theme: { token } }) => token.padding}px;
      }

      .no-margin-bottom {
        margin-bottom: 0;
      }

      td {
        vertical-align: middle;

        .group-title {
          font-size: ${({ theme: { token } }) => token.fontSize}px;
          font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
          margin: ${({ theme: { token } }) => `0 0 ${token.marginXXS}px ${token.margin}px`};
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .total-power-container {
          display: flex;
          justify-content: center;
        }

        .total-power {
          align-self: center;
          padding: ${({ theme: { token } }) => `${token.paddingXXS}px ${token.paddingXS}px`};
          font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
          color: ${({ theme: { token } }) => token.colorBorderSecondary};
          font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
          background-color: ${({ theme: { token } }) => token.colorTextSecondary};
          border-radius: 2px;
          margin-right: ${({ theme: { token } }) => token.margin}px;
        }

        .circle {
          flex-shrink: 0;
          width: 12px;
          height: 12px;
          background-color: ${({ theme: { token } }) => token.colorBgContainer};
          border: 4px solid;
          border-radius: 50%;
          margin-right: ${({ theme: { token } }) => token.marginXS}px;
          display: inline-block;
        }

        .rectangle {
          flex-shrink: 0;
          width: 12px;
          height: 12px;
          background-color: ${({ theme: { token } }) => token.colorSuccess};
          margin-right: ${({ theme: { token } }) => token.marginXS}px;
          display: inline-block;
        }

        .value {
          font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
          margin: 0 ${({ theme: { token } }) => token.marginXXS}px 0 ${({ theme: { token } }) => token.marginXL}px;
        }

        .unit {
          font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        }

        .no-margin-left {
          margin-left: 0;
        }
      }
    }
  }

  .container {
    margin-top: ${({ theme: { token } }) => token.marginXS}px;
    padding: 0 ${({ theme: { token } }) => token.padding}px;
    border-top: 1px solid ${({ theme: { token } }) => token.colorTextSecondary};

    .alert-container {
      display: flex;
      padding: ${({ theme: { token } }) => `${token.paddingXS}px 0`};
      white-space: initial;
      border-bottom: 1px solid ${({ theme: { token } }) => token.colorTextSecondary};

      &:last-child {
        border-bottom: none;
      }

      .alert-severity-icon {
        margin-top: ${({ theme: { token } }) => token.marginXXS}px;
      }

      .alert-text {
        margin-left: ${({ theme: { token } }) => token.marginXS}px;
      }

      .alert-title {
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      }

      .alert-opening-time {
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      }
    }

    .rest-alerts {
      margin-top: ${({ theme: { token } }) => token.marginXS}px;
    }
  }

  .compressors {
    display: grid;
    grid-template-columns: min-content 1fr;
    grid-column-gap: 22px;
    margin: ${({ theme: { token } }) => `${token.marginXXS}px ${token.margin}px 0 ${token.margin}px`};
    font-size: ${({ theme: { token } }) => token.fontSize}px;

    .compressor-name {
      display: flex;
      align-items: center;

      .compressor-square {
        width: 12px;
        height: 12px;
        margin-right: ${({ theme: { token } }) => token.marginXS}px;
      }
    }

    .compressor-status {
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    }
  }

  .dynamic-control-date {
    margin-left: ${({ theme: { token } }) => token.marginXXL}px;
  }

  &.engine-state-only {
    .engine-status-container {
      border-top: none;
      margin-top: 0;
      padding-top: ${({ theme: { token } }) => token.paddingXXS}px;
    }
  }

  .engine-status-container {
    margin-top: ${({ theme: { token } }) => token.marginXS}px;
    border-top: 0.5px solid ${({ theme: { token } }) => token.colorTextSecondary};
    padding-top: ${({ theme: { token } }) => token.paddingXS}px;

    .engine-status-title {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      margin: ${({ theme: { token } }) => `0 0 ${token.marginXXS}px ${token.margin}px`};
    }

    .engine-status-row {
      display: flex;
      align-items: center;
      padding-left: ${({ theme: { token } }) => token.padding}px;
      gap: ${({ theme: { token } }) => token.marginXS}px;
    }
  }

  .dynamic-control-container {
    display: flex;
    align-items: center;
    margin: ${({ theme: { token } }) => `${token.marginXXS}px ${token.margin}px 0 ${token.margin}px`};

    .dynamic-control-legend-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex-grow: 1;

      .dynamic-control-legend {
        display: flex;
        justify-content: center;
        align-items: center;

        .legend-square {
          width: 12px;
          height: 12px;
          margin-right: ${({ theme: { token } }) => token.marginXS}px;
        }

        .dynamic-control-label {
          font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
          font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        }
      }

      .dynamic-control-small-label {
        display: flex;
        justify-content: center;
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        min-width: 250px;
      }
    }
  }
`;
